<div class="header-landing">
  <div class="header-landing__container"
    id="header-landing">
    <img class="header-landing__logo-img"
      [src]="configuration.logoHeader"
      alt="logo header"/>
    <div class="header-nav__items-container">
        @if(skin !== 'icam-red'){
          <button class="common-button__picker-language"
            (click)="menuActionLanguagePickerHeaderLanding.toggle($event)">
            <span-tooltip class="common-button__picker-language-text header-landing__picker-language-text"
              [text]="headerLanding.selectedLanguage.text"></span-tooltip>
            <span-tooltip class="common-button__picker-language-text header-landing__picker-language-text-mobile"
              [text]="headerLanding.selectedLanguage.appLanguage.substring(0, 2).toUpperCase()"></span-tooltip>
            <i class="lf-icon-angle-down common-icon__sm"></i>
          </button>
        }@else{
          <button class="header-nav__button-noborder"
            pTooltip="{{'common.log-out' | afTranslate}}"
            tooltipPosition="bottom"
            (click)="logOut()">
          <i class="lf-icon-close-session common-icon__lg"></i>
          </button>
        }
    </div>
  </div>
  <div class="header-landing__border-bottom"
    [ngClass]="{'header-landing__border-bottom--gradient': configuration.secondaryColor}"></div>
</div>
<p-menu
  #menuActionLanguagePickerHeaderLanding
  styleClass="common-dropdown-list__a-container common-dropdown-list__a-container--scrollable max-h-[198px]"
  appendTo="body"
  [model]="headerLanding.languages"
  [popup]="true">
  <ng-template pTemplate="action"
    let-language>
    <button class="common-dropdown-list__si-button"
        (click)="changeAppLanguage(language)">
        <span-tooltip class="common-dropdown-list__si-text-container-header"
          [text]="language.text + ' (' + language.specific + ')'"
          [tooltipPosition]="'left'"></span-tooltip>
    </button>
  </ng-template>
</p-menu>
